import { ListingProduct } from '@rdss/client'
import { Component, h, Host, Prop } from '@stencil/core'
import { isSponsoredProduct } from '~/utils/tracking'

@Component({
    tag: 'zr-listing-container',
    styleUrl: 'zr-listing-container.scss',
    scoped: true,
})

/**
 * ZrBannerxWrapper.
 */
export class ZrListingContainer {

    /**
     * List of Products.
     */
    @Prop() products: ListingProduct[]

    /**
     * Flag to hide sponsored products.
     */
    @Prop() hideSponsored = false

    /**
     * Category id for bannerx.
     */
    @Prop() category = 1

    /**
     * Search term for bannerx.
     */
    @Prop() searchTerm = ''

    /**
     * Renders the component.
     */
    render() {
        return (
            <Host>
                <div class="grid-container">
                    {this.products?.length > 0 && this.products?.map(currentProduct => (
                        ((!this.hideSponsored || !isSponsoredProduct(currentProduct)) &&
                            currentProduct.sku && currentProduct.name) &&
                        <zr-product-tile key={currentProduct.sku} product={currentProduct} />
                    ))}
                    {(!this.hideSponsored) && (
                        <zr-bannerx-wrapper category={this.category} searchTerm={this.searchTerm} />
                    )}
                </div>
            </Host>
        )
    }
}
